export default "__VITE_ASSET__bbf7b9fc__"